import React from 'react';
import PropTypes from 'prop-types';
import InfoCircleFillIcon from './icons/info-circle-icon';
import Tooltip from './tooltip';

const MarketingReachResults = ({
  sampleSize = 0,
  customersWithEmail = 0,
  percentageWithEmail = 0,
  percentageWithoutEmail = 0
}) => (
  <div className='marketing-reach-results'>
    <div className='sample-container'>
      <div className='sample-header'>
        <span className='sample-tag'>Sample</span>
        <Tooltip content={`We've analyzed ${sampleSize} of your recent customers to estimate the percentage that have an email address.`} position="right">
          <InfoCircleFillIcon size={24} />
        </Tooltip>
      </div>
      <div>
        <h1 className='sample-size'>{customersWithEmail}/{sampleSize}</h1>
      </div>
      <div className='sample-description'>
        <span className='label'>customers with emails</span>
        <Tooltip content="Some customers with email addresses may be excluded if they have turned off permissions or opted out of email marketing." position="right">
          <InfoCircleFillIcon size={24} />
        </Tooltip>
      </div>
    </div>
    <div className='stats-container'>
      <div>
        <strong className='title'>Customer Breakdown</strong>
      </div>
      <div>
        <div className='stat-meter'>
          <div className='stat-meter-fill' style={{ width: `${percentageWithEmail}%` }} />
        </div>
      </div>
      <div>
        <div className='stat-row'>
          <div>
            <div className='swatch fill' />
          </div>
          <div className='stat-fill'>
            <span>Square customers with an email address</span>
          </div>
          <div>
            <span>{percentageWithEmail}%</span>
          </div>
        </div>
        <div className='stat-row'>
          <div>
            <div className='swatch' />
          </div>
          <div className='stat-fill'>
            <span>Square customers without an email address</span>
          </div>
          <div className='stat-email-footnote'>
            <div>
              <Tooltip content="Customers who don't enter their email address for a receipt or to subscribe to email marketing during a purchase won't have emails." position='bottom'>
                <button type="button" className='stat-link'>Why don&#39;t these customers have emails?</button>
              </Tooltip>
            </div>
            <div>
              <span>{percentageWithoutEmail}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

MarketingReachResults.propTypes = {
  sampleSize: PropTypes.number,
  customersWithEmail: PropTypes.number,
  percentageWithEmail: PropTypes.number,
  percentageWithoutEmail: PropTypes.number,
};

export default MarketingReachResults;